/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M5.
 * Account-scoped client for the Eva responses (FAQ) review API
 * (/api/v1/accounts/:account_id/eva/responses[/bulk_approve]).
 */
/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class EvaResponsesAPI extends ApiClient {
  constructor() {
    super('eva/responses', { accountScoped: true });
  }

  // List an assistant's responses, optionally filtered by status (e.g. 'pending' for the review tab).
  getResponses({ assistantId, status } = {}) {
    return axios.get(this.url, {
      params: { eva_assistant_id: assistantId, status },
    });
  }

  // Approve the vetted pending candidates; returns { approved: <count> }.
  bulkApprove({ assistantId, ids }) {
    return axios.post(`${this.url}/bulk_approve`, {
      eva_assistant_id: assistantId,
      ids,
    });
  }

  // Edit a candidate's question/answer (re-embeds server-side when the text changes). Wraps the body
  // in the `response` envelope the controller expects (unlike the inherited flat update).
  updateResponse({ id, question, answer }) {
    return axios.patch(`${this.url}/${id}`, { response: { question, answer } });
  }
}

export default new EvaResponsesAPI();
